"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
var _withSizePresets = _interopRequireDefault(require("../withSizePresets"));
/* eslint-disable max-len */

var Locked = function Locked(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, (0, _extends2["default"])({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.91335 4.91456e-05C4.27637 -0.00825752 2.83907 1.03705 2.1447 2.67033C1.78756 3.57719 1.8088 4.81919 1.82536 5.90371H0V14H12V5.90371H10.015V4.3682C10.015 3.76621 9.89861 3.21056 9.6812 2.67033C9.04561 1.11928 7.55033 0.00835581 5.91335 4.91456e-05ZM5.91335 2.57804C6.86961 2.60508 7.5671 3.37084 7.60872 4.35282V5.90371H4.23161V4.3682C4.32187 3.29925 4.95708 2.55101 5.91335 2.57804Z",
    fill: "#666666"
  })));
};
var _default = (0, _withSizePresets["default"])(20, 20)(Locked);
exports["default"] = _default;
//# sourceMappingURL=Locked.js.map